import React, { useRef } from 'react';
import { useExpediteStore } from '../store/useExpediteStore';
import Card from './UI/Card';
import { formatPhoneNumber } from '../utils/helpers';

const ExpediteSignatureResult = () => {
  const {
    name,
    email,
    position,
    extension,
    cellPhone,
    disclaimer,
    linkedin,
    updatesEmail,
    hasLoadbaseBanner,
    hasWarehouse411Banner,
    pictureUrl,
  } = useExpediteStore();

  const signatureRef = useRef<HTMLDivElement>(null);
  const signatureCopyRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    if (!signatureRef.current) return;

    const html = `
    <!DOCTYPE html>
    <html>
      <head> 
        <meta charset="UTF-8" />
        <title>Signature</title> 
      </head>
      <body>
        ${signatureRef.current.innerHTML}
      </body>
    </html>
  `.trim();

    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'gmail-signature.html';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Card
        title="Your Signature Result"
        action={{
          label: 'Download Signature',
          onClick: () => handleDownload(),
        }}
      >
        <div className="flex flex-col text-sm text-slate-400">
          <p className="pb-4">Hi John,</p>
          <p>
            I hope you're doing well. Please find attached the updated shipping documents for the
            upcoming dispatch scheduled for Friday. Let me know if there’s anything else you need or if
            any changes are required before we proceed.
          </p>
          <p>
            Also, quick reminder that the deadline for final approval is{' '}
            <span className="font-medium">Thursday, 5 PM EST</span>.
          </p>
          <div className="pt-4 pb-6">
            <p>Best regards,</p>
          </div>
        </div>

        {/* Signature */}
        <div ref={signatureRef}>
          <table
            style={{
              color: 'rgb(80, 0, 80)',
              tableLayout: 'fixed',
              width: '620px',
              fontFamily: 'Helvetica, sans-serif',
              fontSize: '14px',
            }}
          >
            <tbody>
            <tr>
              <td
                style={{
                  borderRight: '1px solid rgb(226, 232, 240)',
                  borderTop: '1px solid rgb(226, 232, 240)',
                  width: '190px',
                  verticalAlign: 'top',
                }}
              >
                <img
                  alt="SIERRA EXPEDITING INC"
                  src="https://sendsierra.com/sierra.png"
                  style={{
                    width: '159px',
                    height: '60px',
                    marginTop: '0.5rem',
                    marginLeft: '0.5rem',
                  }}
                />
                <p
                  style={{
                    margin: '0.5rem 0px 0px',
                    padding: 0,
                    color: 'rgb(39, 39, 42)',
                    textAlign: 'center',
                    fontSize: '10px',
                  }}
                >
                  <b>Solving Tomorrow&apos;s Problems...</b>
                </p>
                <p
                  style={{
                    margin: '0.2rem 0px 0px',
                    padding: 0,
                    color: 'rgb(5, 143, 244)',
                    textAlign: 'center',
                    fontSize: '10px',
                  }}
                >
                  <b>TODAY.</b>
                </p>
                <p style={{ margin: '0.5rem 0px 0px' }}>
                  {pictureUrl && (
                    <img
                      src={pictureUrl}
                      width={120}
                      height={120}
                      alt="Profile"
                      style={{
                        borderRadius: '50%',
                        display: 'block',
                        margin: '0 auto'
                      }}
                    />
                  )}
                </p>
              </td>

              <td
                style={{
                  width: '420px',
                  paddingLeft: '1rem',
                  borderTop: '1px solid rgb(226, 232, 240)',
                }}
              >
                <table
                  cellSpacing={0}
                  cellPadding={0}
                  border={0}
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '14px',
                    lineHeight: '1.4',
                    color: '#000',
                    width: '100%',
                    maxWidth: '500px',
                  }}
                >
                  <tbody>
                  <tr>
                    <td style={{ verticalAlign: 'top', paddingTop: '5px', width: '100%' }}>
                      <p style={{ margin: 0, padding: 0, fontSize: '15px', fontWeight: 'bold' }}>
                        {name || 'John Doe'}
                        {linkedin && (
                          <a
                            href={linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              marginLeft: '6px',
                              textDecoration: 'none',
                              display: 'inline-block',
                              verticalAlign: 'middle',
                            }}
                          >
                            <img
                              src="https://sendsierra.com/in.png"
                              width={18}
                              height={18}
                              alt="LinkedIn"
                              style={{ display: 'inline-block', border: 'none', marginTop: '-7px' }}
                            />
                          </a>
                        )}
                      </p>
                      <p
                        style={{
                          margin: '2px 0',
                          padding: 0,
                          color: '#94a3b8',
                          fontWeight: 'bold',
                        }}
                      >
                        {position || 'Dispatch'}
                      </p>
                      <p
                        style={{
                          margin: '2px 0',
                          padding: 0,
                          color: '#058ff4',
                          fontWeight: 'bold',
                        }}
                      >
                        SIERRA EXPEDITING INC
                      </p>
                      <p style={{ margin: '4px 0', padding: 0 }}>
                        <span
                          style={{
                            backgroundColor: '#058ff4',
                            color: '#fff',
                            fontWeight: 'bold',
                            padding: '2px 6px',
                            borderRadius: '3px',
                            display: 'inline',
                          }}
                        >
                          MC: 568961
                        </span>
                        <span style={{ display: 'inline-block', width: '8px' }}></span>
                        <span
                          style={{
                            backgroundColor: '#058ff4',
                            color: '#fff',
                            fontWeight: 'bold',
                            padding: '2px 6px',
                            borderRadius: '3px',
                            display: 'inline',
                          }}
                        >
                          DOT: 1523843
                        </span>
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <table cellPadding={0} cellSpacing={0} border={0} width="100%">
                  <tbody>
                  <tr>
                    <td style={{ paddingTop: '0.5rem', color: '#000' }}>
                      <p style={{ margin: '0.1rem 0', padding: 0 }}>
                            <span style={{ color: '#058ff4' }}>
                              <b>P: </b>
                            </span>
                        <a
                          href="tel:+19168180800"
                          rel="noopener noreferrer"
                          target="_blank"
                          style={{ color: '#09090b', textDecoration: 'none' }}
                        >
                          (916) 818 0800 {extension ? `ext.${extension}` : ''}
                        </a>{' '}
                        <span style={{ color: '#058ff4' }}>
                              <b>F: </b>
                            </span>
                        <a
                          href="tel:+19168180808"
                          rel="noopener noreferrer"
                          target="_blank"
                          style={{ color: '#09090b', textDecoration: 'none' }}
                        >
                          (916) 818 0808
                        </a>{' '}
                        {cellPhone && (
                          <>
                            <span style={{ color: '#058ff4' }}>
                              <b>M: </b>
                            </span>
                            <a
                              href={`tel:${formatPhoneNumber(cellPhone)}`}
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: '#09090b', textDecoration: 'none' }}
                            >
                              {cellPhone}
                            </a>
                          </>
                        )}
                      </p>

                      <p style={{ margin: '0.1rem 0', padding: 0 }}>
                            <span style={{ color: '#058ff4' }}>
                              <b>E: </b>
                            </span>
                        <a
                          href={`mailto:${email}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#09090b', textDecoration: 'none' }}
                        >
                          {email || 'john.doe@sendsierra.com'}
                        </a>
                      </p>

                      <p style={{ margin: '0.1rem 0', padding: 0 }}>
                            <span style={{ color: '#058ff4' }}>
                              <b>W: </b>
                            </span>
                        <a
                          href="https://sendsierra.com"
                          target="_blank"
                          style={{ color: '#09090b', textDecoration: 'none' }}
                        >
                          sendsierra.com
                        </a>
                      </p>

                      {updatesEmail && (
                        <p style={{ margin: '0.1rem 0', padding: 0 }}>
                              <span style={{ color: '#058ff4' }}>
                                <b>For updates email: </b>
                              </span>
                          <a
                            href={`mailto:${updatesEmail}`}
                            target="_blank"
                            style={{ color: '#09090b', textDecoration: 'none' }}
                          >
                            {updatesEmail}
                          </a>
                        </p>
                      )}
                    </td>
                  </tr>
                  </tbody>
                </table>

                {/* Certifications */}
                <table cellSpacing={0} border={0} role="presentation" style={{ marginTop: '0.5rem' }}>
                  <tbody>
                  <tr>
                    <td>
                      <img
                        src="https://sendsierra.com/certifications/inc5000.png"
                        width={47}
                        height={34}
                        alt="Inc5000"
                        style={{ display: 'block', border: 0 }}
                      />
                    </td>
                    <td>
                      <img
                        src="https://sendsierra.com/certifications/tsa.png"
                        width={32}
                        height={32}
                        alt="TSA"
                        style={{ display: 'block', border: 0, marginLeft: '7px' }}
                      />
                    </td>
                    <td>
                      <img
                        src="https://sendsierra.com/certifications/twic.png"
                        width={41}
                        height={16}
                        alt="TWIC"
                        style={{ display: 'block', border: 0, marginLeft: '7px'}}
                      />
                    </td>
                    <td>
                      <img
                        src="https://sendsierra.com/certifications/ctpat.png"
                        width={62}
                        height={13}
                        alt="CTPAT"
                        style={{ display: 'block', border: 0, marginLeft: '7px' }}
                      />
                    </td>
                    <td>
                      <img
                        src="https://sendsierra.com/certifications/tapa.png"
                        width={67}
                        height={10}
                        alt="TAPA"
                        style={{ display: 'block', border: 0, marginLeft: '7px' }}
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>

                {(hasLoadbaseBanner || hasWarehouse411Banner) && (
                  <table cellPadding={0} cellSpacing={0} border={0} style={{ marginTop: '0.75rem' }}>
                    <tbody>
                    <tr>
                      {hasLoadbaseBanner && (
                        <td style={{ paddingRight: hasWarehouse411Banner ? '15px' : '0px' }}>
                          <img
                            src="https://sendsierra.com/loadbase.png"
                            width={110}
                            height={20}
                            alt="Loadbase"
                            style={{ display: 'block', border: 0 }}
                          />
                        </td>
                      )}
                      {hasWarehouse411Banner && (
                        <td>
                          <img
                            src="https://sendsierra.com/wh411.png"
                            width={160}
                            height={20}
                            alt="Warehouse411"
                            style={{ display: 'block', border: 0 }}
                          />
                        </td>
                      )}
                    </tr>
                    </tbody>
                  </table>
                )}
              </td>
            </tr>
            </tbody>
          </table>

          {disclaimer && (
            <table style={{ width: '620px', marginTop: '0.75rem' }}>
              <tbody>
              <tr>
                <td style={{ fontSize: '10px', color: '#64748b', textAlign: 'justify' }}>
                  {disclaimer}
                </td>
              </tr>
              </tbody>
            </table>
          )}
        </div>

        <div
          ref={signatureCopyRef}
          style={{ position: 'absolute', left: '-9999px', top: 0 }}
          contentEditable
          dangerouslySetInnerHTML={{ __html: signatureRef.current?.outerHTML ?? '' }}
        />
      </Card>
    </>
  );
};

export default ExpediteSignatureResult;
